import { render } from "./AppStore.vue?vue&type=template&id=25c30003&lang=pug"
import script from "./AppStore.vue?vue&type=script&lang=js"
export * from "./AppStore.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__